import { connect } from 'react-redux';
import RejectedAccreditationsManagementComponent from './RejectedAccreditationsManagementComponent';
import { getTranslation } from "../../../reducers/common/localization";
import { getRejectedBy, setRejectedBy, clearAccreditationsCountryFilter } from './../../../reducers/accreditation/accreditations';
import {
    fetchGetRejectedAccreditationsNotifications, getNotificationsData
} from "../../../reducers/common/notifications";
import {getCurrentGroup} from "../../../reducers/account/role";

const mapStateToProps = (state) => {
    return {
        rejectedBy: getRejectedBy(state),
        translation: getTranslation(state),
        notifications: getNotificationsData(state),
        groupId: getCurrentGroup(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onGetNotifications: (groupId) => {
            dispatch(fetchGetRejectedAccreditationsNotifications(groupId))
        },
        onChangeRejectedBy: (value) => dispatch(setRejectedBy(value)),
        onClearCountryFilter: () => dispatch(clearAccreditationsCountryFilter()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(RejectedAccreditationsManagementComponent);



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/rejectedAccreditationsManagementComponent/RejectedAccreditationsManagementComponent.container.js